var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07265 19.1486C1.23895 13.2105 -2.07691 5.36778 1.44533 1.27835C2.17454 0.424056 4.22459 -0.402232 4.91253 0.213983C5.54543 0.802188 5.57295 1.93658 6.60486 3.78523C7.34783 5.10169 7.99449 5.45181 7.95321 6.12404C7.87066 7.46851 5.79309 7.69259 5.82061 9.40119C5.86188 11.5019 7.19648 14.0508 8.84753 15.7174C10.5536 17.454 12.5624 18.6024 14.2134 18.6724C15.6443 18.7284 15.9608 17.0759 17.2954 16.8658C17.9696 16.7537 18.4374 17.6221 19.7857 18.6304C20.9965 19.5407 22.9365 20.1009 22.9915 20.8712C23.0878 22.0756 22.3448 23.168 21.7807 23.7282C19.4555 25.997 13.4705 25.6609 7.07265 19.1486Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c5ba56f7fddeefaea90bcab34b39d466.svg";
export { ForwardRef as ReactComponent };